import { render, staticRenderFns } from "./Deduction.vue?vue&type=template&id=250b8f64&scoped=true&"
import script from "./Deduction.vue?vue&type=script&lang=js&"
export * from "./Deduction.vue?vue&type=script&lang=js&"
import style0 from "./Deduction.vue?vue&type=style&index=0&id=250b8f64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250b8f64",
  null
  
)

export default component.exports